import { PaymentElement } from "@stripe/react-stripe-js";
import { useState } from "react";
import { useStripe, useElements } from "@stripe/react-stripe-js";
import { Button,Box } from "@chakra-ui/react";
import {  useNavigate } from "react-router-dom";

export default function CheckoutForm() {
  const stripe = useStripe();
  const elements = useElements();
  const [message, setMessage] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsProcessing(true);

    const { error } = await stripe.confirmPayment({
      elements,

      confirmParams: {
        // Make sure to change this to your payment completion page
        return_url: `${window.location.origin}/success`,
      },
    });

     
    if (error.type === "card_error" || error.type === "validation_error") {
      setMessage(error.message);
      navigate("/paymentfail")
    } else {
      setMessage("An unexpected error occured.");
      navigate("/paymentfail")
    }

    setIsProcessing(false);
  };

  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      <Box mx={'4'} my={'1'} colorScheme={'yellow'}>
        <PaymentElement id="payment-element"/>
        <button disabled={isProcessing || !stripe || !elements} id="submit">
          <span id="button-text">
          <Button my="4" p={'4'} colorScheme={'yellow'} type="submit">
          {isProcessing ? "Processing ... " : "Pay now"}
            </Button>
          </span>
        </button>
        {/* Show any error or success messages */}
        {message && <div id="payment-message">{message}</div>}
      </Box>
      
    </form>
  );
}